<template>
    <div class="items-center p-6">
        <div class="flex items-center pb-3">
            <div class="chart-inner-headline pl-4">{{label}}</div>
            <div class="flex items-center ml-auto">
                <div class="text-3xl pr-4">{{userCount}}</div>
                <icon name="users" class="w-10 h-10 fill-gray-700 mt-2"></icon>
            </div>
        </div>
        <div class="">
            <UsersOnTtaPageBar
                :data="this.data"
                :labels="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]"
                :chart-label="$t('pages.controlpanel.index.controls.visitors_on_tta_page_label')"
                :width="400"
                :height="200"
            ></UsersOnTtaPageBar>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import UsersOnTtaPageBar from "@/Shared/Charts/UsersOnTtaPageBar";


export default {
    components: {
        UsersOnTtaPageBar,
        Link,
        Icon
    },
    props: {
        label: String,
        userCount: Number,
        data: Array
    }
}
</script>
